import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { SliderWrapper, SlideWrapper } from './styled'
import { Slide } from 'pure-react-carousel'
import { Carousel } from 'components/Slider'
import { useIsMobile } from 'hooks/responsive'

export const Slider = () => {
  const isMobile = useIsMobile()
  const id = CMS_BLOCK.HOME_SLIDER
  const cmsBlock = useCmsBlock({
    id,
    isLazy: false

  })
  const content = cmsBlock?.content

  const SlidesParent = document.createElement('div')
  SlidesParent.innerHTML = content
  const slideElements = SlidesParent.querySelectorAll('.carousel-cell')
  const slideItems = Array.prototype.slice.call(slideElements)

  return (
    <SliderWrapper>
      <Carousel
        child={slideItems}
        renderChildren={(children: any[]) => {
          return children.map((child: any, index: number) => {
            return (
              <Slide index={index} key={index}>
                <SlideWrapper
                  dangerouslySetInnerHTML={{
                    __html: child.innerHTML
                  }}
                />
              </Slide>
            )
          })
        }}
        autoPlay
        arrowsEnabled={slideItems?.length > 1 && !isMobile}
        autoHeight
      />
    </SliderWrapper>
  )
}
